import { ReactNode } from 'react'

type DetailsSectionProps = {
  title: string
  children?: ReactNode
}

const DetailsSection = ({ title, children }: DetailsSectionProps) => {
  return (
    <section className="flex flex-col gap-5">
      <div className="bg-primary-200 px-4 py-3">
        <h6 className="typography-body-l text-neutral-800 font-semibold uppercase tracking-[0.4px]">{title}</h6>
      </div>
      <div className="flex flex-col gap-4">{children}</div>
    </section>
  )
}

export default DetailsSection
